// =====================================================================
// DATE ENHANCE — DISABLED (no-op)
// =====================================================================
// The custom body-tooltip approach was rejected by the user ("سيئ جدا").
// Frappe v16 already ships a NATIVE dual Gregorian+Hijri datepicker
// (jQuery UI: `#ui-datepicker-div` / `.ui-datepicker-calendar-with-hijri`).
// We must NOT shadow it with a custom tooltip — we only SKIN the native
// widget in `_dates.scss`. So this module deliberately does nothing.
// Export kept stable so the bundle entry stays unchanged.
// =====================================================================

export const dateEnhance = {
	mount() {
		/* no-op by design — native Frappe Hijri datepicker is used. */
	},
};
